import {getOtherUserFromConversation} from '../scenes/SendbirdMessenger/util'
import {getMessengerClient} from '../utils/messenger'

export const sbGetChannelTitle = channel => {
  if (channel.isOpenChannel()) {
    return channel.name
  }
  let user = getOtherUserFromConversation(channel)
  return user.nickname
}

export const sbGetChannelPicture = channel => {
  let user = getOtherUserFromConversation(channel)
  return user.profileUrl
}

export const sbBlockedInfo = channel => {
  let user = getOtherUserFromConversation(channel)
  if (user) {
    return {userId: user.userId, isBlockingMe: user.isBlockingMe, isBlockedByMe: user.isBlockedByMe}
  }
  return {userId: null, isBlockingMe: false, isBlockedByMe: false}
}

export const sbIsImageMessage = message => {
  return message.type.match(/^image\/.+$/)
}

export const sbAdjustMessageList = list => {
  return list.map((message, i) => {
    message['time'] = sbUnixTimestampToDate(message.createdAt)
    message['readCount'] = 0
    if (message.isUserMessage() || message.isFileMessage()) {
      message['isUser'] = (message.sender.userId === getMessengerClient().getCurrentUserId())
    } else {
      message['isUser'] = false
    }
    if (message.sender) {
      message.sender['isShow'] = true
      if (!message.sender.profileUrl) {
        message.sender.profileUrl = 'default-image'
      }
    }

    if (i < list.length - 1) {
      let prevMessage = list[i + 1]
      if (message.isUserMessage() || message.isFileMessage()) {
        if (prevMessage.isUserMessage() || prevMessage.isFileMessage()) {
          if (prevMessage.sender.userId === message.sender.userId) {
            message.sender.isShow = false
          }
        }
      }
    }
    return message
  })
}

export const sbUnixTimestampToDate = unixTimestamp => {
  const today = new Date()
  const date = new Date(unixTimestamp)

  if (today.getMonth() !== date.getMonth() || today.getDay() !== date.getDay()) {
    return date.getMonth() + '/' + date.getDay()
  }
  const hour = '0' + date.getHours()
  const minute = '0' + date.getMinutes()
  return hour.substr(-2) + ':' + minute.substr(-2)
}
